import React from "react";

import { useConfirmedAction } from "@/routes/admin/components/user/user";

const useFormConfirmation = <T>() => {
  const { runWhenConfirmed, dialog, rejectRef, resolveRef } =
    useConfirmedAction();
  const formDataRef = React.useRef<T | null>(null);

  const confirm = (
    message: React.ReactNode,
    data: T,
    callback: (data: T) => void,
  ) => {
    formDataRef.current = data;
    runWhenConfirmed(message, () => callback(data))();
  };

  return {
    confirm,
    dialog,
    formData: formDataRef.current,
    rejectRef,
    resolveRef,
  };
};

export { useFormConfirmation };
